export default __webpack_public_path__ + "static/media/ISEO_CLASS-9_SYLLABUS_2025-26.3c721b4b.pdf";